export const acc = () => {
  const accordions = document.querySelectorAll('.accordion');
  if (accordions) {
    accordions.forEach(el => {
      el.addEventListener('click', e => {
        const self = e.currentTarget;
        const control = self.querySelector('.accordion__control');
        const content = self.querySelector('.accordion__content');
        const last = self.querySelector('.accordion__control-last');
        self.classList.toggle('open'); // если открыт аккордеон

        if (self.classList.contains('open')) {
          control.setAttribute('aria-expanded', true);
          content.setAttribute('aria-hidden', false);
          content.style.maxHeight = content.scrollHeight + 'px';

          if (control.classList.contains('accordion__control-last')) {
            last.classList.remove('last');
          }
        } else {
          control.setAttribute('aria-expanded', false);
          content.setAttribute('aria-hidden', true);
          content.style.maxHeight = null;

          if (control.classList.contains('accordion__control-last')) {
            last.classList.add('last');
          }
        }
      });
    });
  }

  const acc1 = document.querySelector('.accordion-1');
  const path1 = document.querySelector('.vec__1 path');
  const circle1= document.querySelector('.vec__1 circle');
  const vec_2 = document.querySelector('.vec__2')
  const vec_3 = document.querySelector('.vec__3')

  acc1.addEventListener('click', el => {
    const height = 520;

    if (acc1.classList.contains('open')) {

      path1.setAttribute('d', `M28 0 L30 ${height-20} Q30 ${height} 0 ${height}`)
      circle1.setAttribute('cy', `${height}`)
      vec_2.classList.add('active')
      vec_3.classList.add('active')
    } else {

      path1.setAttribute('d', `M28 0 L30 200 Q30 260 6 260`)
      circle1.setAttribute('cy', `260`)
      vec_2.classList.remove('active')
      vec_3.classList.remove('active')

    }

  })

  const acc2 = document.querySelector('.accordion-2');
  const path2 = document.querySelector('.vec__2 path');
  const circle2= document.querySelector('.vec__2 circle');

  acc2.addEventListener('click', el => {
    const height = 610;

    if (acc2.classList.contains('open')) {
      path2.setAttribute('d', `M20 6 Q10 6 10 16 L10 ${height - 20} Q10 ${height} 22 ${height}`)
      circle2.setAttribute('cy', `${height}`)
    } else {
      path2.setAttribute('d', `M20 6 Q10 6 10 16 L10 220 Q10 230 22 230`)
      circle2.setAttribute('cy', `230`)

    }

  })
}
